import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { messages } from './Appointments.i18n';
import {
  providerDropdownConfig,
  statusDropdownConfig,
  apptTypeDropdownConfig,
  apptDateButtonGroupConfig,
} from './AppointmentFilterConfig';
import CollapseButton from '../../components/Filter/CollapseButton';
import FilterPanel from '../../components/Filter/FilterPanel';
import { toggleFilterPanel, appointmentsFiltered } from '../../redux/modules/appointment/actions/creators';
import { getDefaultFilter } from '../../redux/modules/appointment/appointment-reducer';

class AppointmentFilters extends Component {
  handleCollapseEvent = () => {
    this.props.dispatch(toggleFilterPanel(!this.props.showFilterPanel));
  }

  render() {
    const { formatMessage } = this.props.intl;

    const filterValues = [
      {
        id: 'provider-filter',
        ref: 'providerfilter',
        list: providerDropdownConfig(this.props, formatMessage),
        label: messages.filter.provider,
        xsSize: 12,
        smSize: 4,
        mdSize: 3,
      },
      {
        id: 'appt-status-filter',
        ref: 'apptStatusFilter',
        list: statusDropdownConfig(this.props, formatMessage),
        label: messages.filter.status,
        xsSize: 12,
        smSize: 4,
        mdSize: 3,
      },
      {
        id: 'appt-type-filter',
        ref: 'apptTypeFilter',
        list: apptTypeDropdownConfig(this.props, formatMessage),
        label: messages.filter.appointmentType,
        xsSize: 12,
        smSize: 4,
        mdSize: 3,
      },
    ];
    const dateValues = apptDateButtonGroupConfig(this.props, formatMessage);

    return (
      <div>
        <CollapseButton isOpen={ this.props.showFilterPanel } onClick={ this.handleCollapseEvent } />
        <div className="collapse-button-info">
          <FormattedMessage
            { ...messages.filter.filterMessage }
            values={{
              filteredRows: this.props.filteredRows || '0',
              allRows: this.props.allRows || '0',
              rowItemName:
                <span className="hidden-xs">&nbsp;{
                  formatMessage(messages.filter.appointments)
                }
                </span>,
            }}
          />
        </div>
        <FilterPanel isOpen={ this.props.showFilterPanel }
          createFilterChangeAction={ appointmentsFiltered }
          filterValues={ filterValues }
          dateValues={ dateValues }
          filter={ this.props.filter }
          keyDateFilterPreference="PatientPortal_AppointmentsFilter_Date"
          clearFilter={ getDefaultFilter() }
        />
      </div>
    );
  }
}

AppointmentFilters.propTypes = {
  dispatch: PropTypes.func,
  filterOptions: PropTypes.object,
  filter: PropTypes.object,
  intl: PropTypes.object,
  showFilterPanel: PropTypes.bool,
  filteredRows: PropTypes.number,
  allRows: PropTypes.number,
};

const mapStateToProps = (state) => ({
  filterOptions: state.appointment.filterOptions,
  filter: state.appointment.filter,
  showFilterPanel: state.appointment.showFilterPanel,
});

export default connect(mapStateToProps)(injectIntl(AppointmentFilters));